export function getEpochTime(isoString?: string): number {
  if (!isoString) {
    return 0;
  }
  return new Date(isoString).valueOf() / 1000;
}

export function getIsoString(epochTime?: number): string {
  if (epochTime === undefined || epochTime === null) {
    return '';
  }

  return new Date(epochTime * 1000).toISOString();
}
